An array of up to 10 event objects.
